/* eslint-disable max-params */
type ProgressServerConfigFunction = (
  computable: boolean,
  loaded: number,
  total: number,
  cb?: (percent: number) => void
) => void;

export const progressServerConfig: ProgressServerConfigFunction = (
  computable,
  loaded,
  total,
  cb
) => {
  if (!computable) {
    console.log('Uploading... (size unknown)');
    return;
  }

  const percent = ((loaded / total) * 100).toFixed(0);
  cb?.(Number(percent));
};
